import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-c53f655e"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  id: "command-line-input",
  class: "d-flex flex-wrap"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "machine-name" }, "ruichen@Portfolio", -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, ":", -1))
const _hoisted_4 = { class: "dir" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "$", -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "command-margin" }, null, -1))
const _hoisted_7 = { key: 0 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _hoisted_3,
    _createElementVNode("span", _hoisted_4, _toDisplayString(this.dirPath), 1),
    _hoisted_5,
    _hoisted_6,
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(this.commandChars, (ch, index) => {
      return (_openBlock(), _createElementBlock("div", {
        class: _normalizeClass(
        index === this.cursorPosition && this.showCursor
          ? 'cursor-highlight command-char'
          : 'command-char'
      ),
        key: index
      }, _toDisplayString(ch), 3))
    }), 128)),
    (this.cursorPosition === this.commandChars.length && this.showCursor)
      ? (_openBlock(), _createElementBlock("span", _hoisted_7, " ▌ "))
      : _createCommentVNode("", true)
  ]))
}